export enum MessageSource {
	DME = 'Dme',
	REV = 'Rev',
	REV_CONNECT = 'RevConnect',
	REV_TV = 'RevTv',
	VBM = 'Vbm'
}
